<template>
	<div
		class="g-block-pay-unlock"
		:class="{
			'g-block-pay-unlock--edit': editable,
			'is-active': editable && active,
			'g-block-pay-unlock--fixed-viewport': fixedBottom && !editable,
			'g-block-pay-unlock--fixed-slot': fixedBottom && editable,
			'g-block-pay-unlock--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-pay-unlock__card"
			:class="{
				'g-block-pay-unlock__card--stack-action': stackAction,
			}"
		>
			<div v-if="$slots.left" class="g-block-pay-unlock__left">
				<slot name="left" />
			</div>
			<div class="g-block-pay-unlock__info">
				<slot name="info" />
			</div>
			<div
				class="g-block-pay-unlock__action"
				:class="{ 'g-block-pay-unlock__action--stack': stackAction }"
			>
				<slot name="action" />
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from './mixin.js';

	export default {
		name: 'GPayUnlockShell',
		mixins: [payUnlockMixin],
		props: {
			stackAction: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-unlock {

		&--fixed-viewport,
		&--fixed-slot {
			padding: 0;
		}

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {
			padding: 0.16rem 0.24rem;

			&.g-block-pay-unlock--fixed-viewport,
			&.g-block-pay-unlock--fixed-slot {
				padding: 0;
			}
		}
	}

	.g-block-pay-unlock__card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		background: #fff;
		padding: 10px;
		border-top: 1px solid #e5e5e5;
	}

	.g-block-pay-unlock__left {
		flex-shrink: 0;
	}

	.g-block-pay-unlock__info {
		flex: 1;
		min-width: 0;
	}

	.g-block-pay-unlock__action {
		flex-shrink: 0;
		display: flex;
		align-items: center;

		&--stack {
			flex-direction: column;
			align-items: flex-end;
			gap: 4px;
		}
	}

	.g-block-pay-unlock--h5 {
		.g-block-pay-unlock__card {
			gap: 0.2rem;
			padding: 0.2rem;
		}

		.g-block-pay-unlock__action--stack {
			gap: 0.08rem;
		}
	}
</style>

<style scoped lang="less">
	.g-block-pay-unlock :deep(.g-block-pay-unlock__tag) {
		flex-shrink: 0;
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 4px;
		white-space: nowrap;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__info .g-block-pay-unlock__tag) {
		margin-bottom: 4px;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__title) {
		margin: 0;
		font-size: 14px;
		font-weight: 700;
		line-height: 1.4;
		color: #222;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__desc) {
		margin: 4px 0 0;
		font-size: 12px;
		line-height: 1.4;
		color: #999;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__prices) {
		display: flex;
		align-items: baseline;
		gap: 6px;
		flex-wrap: wrap;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__price) {
		font-size: 22px;
		font-weight: 700;
		line-height: 1.2;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__price--sm) {
		font-size: 18px;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__original) {
		font-size: 13px;
		color: #bbb;
		text-decoration: line-through;
		line-height: 1.2;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__count) {
		margin: 4px 0 0;
		font-size: 12px;
		color: #999;
		line-height: 1.4;

		em {
			font-style: normal;
			font-weight: 500;
		}
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__btn) {
		flex-shrink: 0;
		min-width: 88px;
		height: 36px;
		padding: 0 16px;
		border: none;
		border-radius: 999px;
		font-size: 15px;
		font-weight: 500;
		color: #fff;
		cursor: pointer;
		white-space: nowrap;
		line-height: 36px;
		text-align: center;
	}

	.g-block-pay-unlock :deep(.g-block-pay-unlock__sub-action) {
		margin: 0;
		font-size: 11px;
		color: #999;
		line-height: 1.3;
		text-align: right;
		white-space: nowrap;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__tag) {
		padding: 0.04rem 0.16rem;
		font-size: 0.24rem;
		border-radius: 0.08rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__title) {
		font-size: 0.28rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__desc) {
		margin: 0.08rem 0 0;
		font-size: 0.24rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__prices) {
		gap: 0.12rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__price) {
		font-size: 0.44rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__price--sm) {
		font-size: 0.36rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__original) {
		font-size: 0.26rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__count) {
		margin: 0.08rem 0 0;
		font-size: 0.24rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__btn) {
		min-width: 1.76rem;
		height: 0.72rem;
		padding: 0 0.32rem;
		font-size: 0.3rem;
		line-height: 0.72rem;
	}

	.g-block-pay-unlock--h5 :deep(.g-block-pay-unlock__sub-action) {
		font-size: 0.22rem;
	}
</style>
